import { render } from "./Index.vue?vue&type=template&id=88b59150&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=88b59150&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-88b59150"

export default script